import { brandName, contactEmail, navItems } from "../data";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-secondary-800 text-background-100">
      <div className="banner-strip h-2 w-full" aria-hidden="true"></div>
      <div className="site-container py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-1">
            <a href="#top" className="inline-flex items-center gap-2.5">
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-radar-line text-lg w-5 h-5 flex items-center justify-center" aria-hidden="true"></i>
              </span>
              <span className="font-serif text-lg font-bold text-background-50">{brandName}</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-200/85">
              一本为吃瓜群众准备的「防塌手册」。用客观的盘点、可读的信号与清晰的边界，
              陪你做清醒、理性、有分寸的娱乐参与者。
            </p>
            <p className="mt-4 text-sm text-background-200/75">
              联系邮箱：
              <a
                href={`mailto:${contactEmail}`}
                rel="noopener"
                className="text-accent-300 hover:text-accent-200 transition-colors"
              >
                {contactEmail}
              </a>
            </p>
          </div>

          <nav className="md:col-span-1" aria-label="页脚导航">
            <h3 className="text-sm font-bold uppercase tracking-widest text-background-100">
              栏目导航
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="inline-flex items-center gap-1.5 text-sm text-background-200/85 transition-colors hover:text-background-50 whitespace-nowrap"
                  >
                    <i className="ri-arrow-right-s-line text-accent-400 text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#about"
                  className="inline-flex items-center gap-1.5 text-sm text-background-200/85 transition-colors hover:text-background-50 whitespace-nowrap"
                >
                  <i className="ri-arrow-right-s-line text-accent-400 text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                  关于我们
                </a>
              </li>
            </ul>
          </nav>

          <div className="md:col-span-1">
            <h3 className="text-sm font-bold uppercase tracking-widest text-background-100">免责声明</h3>
            <p className="mt-4 text-xs md:text-sm leading-relaxed text-background-200/75">
              本站为娱乐生态观察类内容，仅提供通用风险科普与方法论，不针对任何真实人物或事件作事实定性，亦不代表任何官方立场。
              请读者理性看待，以官方与权威渠道信息为准，不传播未经证实的说法，不对任何人进行网络暴力。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-200/15 pt-6">
          <p className="text-xs text-background-200/70">
            © {year} {brandName} · 做一个清醒吃瓜人
          </p>
          <p className="text-xs text-background-200/60">本网站内容仅供娱乐与科普参考</p>
        </div>
      </div>
    </footer>
  );
}